import { inject, Provider } from '@angular/core';
import { InMemoryCache } from '@apollo/client/core';
import { environment } from '@app/environment';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
// eslint-disable-next-line import/extensions
import extractFiles from 'extract-files/extractFiles.mjs';
// eslint-disable-next-line import/extensions
import isExtractableFile from 'extract-files/isExtractableFile.mjs';

export function provideGraphQl(): Provider {
  return [
    provideApollo(() => {
      const httpLink = inject(HttpLink);

      return {
        link: httpLink.create({
          uri: environment.graphql,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          extractFiles: (body) => extractFiles(body, isExtractableFile),
        }),
        cache: new InMemoryCache(),
        // https://github.com/kamilkisiela/apollo-angular/issues/2251
        connectToDevTools: false,
      };
    }),
  ];
}
